import { render, staticRenderFns } from "./DrawerDetailsContact.vue?vue&type=template&id=0fab140a&scoped=true&"
import script from "./DrawerDetailsContact.vue?vue&type=script&lang=js&"
export * from "./DrawerDetailsContact.vue?vue&type=script&lang=js&"
import style0 from "./DrawerDetailsContact.vue?vue&type=style&index=0&id=0fab140a&prod&lang=sass&scoped=true&"
import style1 from "./DrawerDetailsContact.vue?vue&type=style&index=1&id=0fab140a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab140a",
  null
  
)

export default component.exports